// src/config/menuConfig.js
const menuConfig = {
  super_admin: [
    { label: "Dashboard", to: "/Super-Dash" },
    { label: "Company List", to: "/company-list" },
    {
      label: "Users",
      children: [
        { label: "Add New", to: "/add-user" },
        { label: "Users List", to: "/users-list" },
      ],
    },
    {
      label: "Leads",
      children: [
        { label: "New Lead", to: "/newleads" },
        { label: "My Leads", to: "/myleads" },
        { label: "Validate Lead", to: "/validatelead" },
      ],
    },
    {
      label: "Marketing",
      children: [
        { label: "New Influencer", to: "/newinfluencer" },
        { label: "View Influencer", to: "/users-list" },
      ],
    },
    { label: "Payout", to: "/payout" },
    { label: "Profile", to: "/userprofile" },
    { label: "Telecalling", to: "/telecalling-dashboard" },
  ],
  manager: [
    { label: "Dashboard", to: "/Super-Dash" },
    { label: "Company List", to: "/company-list" },
    {
      label: "Users",
      children: [
        { label: "Add New", to: "/add-user" },
        { label: "Users List", to: "/users-list" },
      ],
    },
    {
      label: "Leads",
      children: [
        { label: "New Lead", to: "/newleads" },
        { label: "My Leads", to: "/myleads" },
        { label: "Validate Lead", to: "/validatelead" },
      ],
    },
    {
      label: "Marketing",
      children: [
        { label: "New Influencer", to: "/newinfluencer" },
        { label: "View Influencer", to: "/users-list" },
      ],
    },
    { label: "Payout", to: "/payout" },
    { label: "Profile", to: "/userprofile" },
    { label: "Telecalling", to: "/telecalling-dashboard" },
  ],
  executive: [
    { label: "Dashboard", to: "/dashboard" },
    {
      label: "Leads",
      children: [
        { label: "New Lead", to: "/newleads" },
        { label: "My Leads", to: "/myleads" },
        { label: "Validate Lead", to: "/validatelead" },
      ],
    },
    
    { label: "Payout", to: "/payout" },
    { label: "Profile", to: "/userprofile" },
    { label: "Telecalling", to: "/telecalling-dashboard" },
  ],
  cb_executive: [
    { label: "Dashboard", to: "/dashboard" },
    { label: "CompanyList", to: "/company-list" },
    { label: "EligibilityLeads", to: "/eligibility-leads" },
    { label: "Telecalling",
      children: [
        { label: "Calling", to: "/telecalling" },
        { label: "Add Data", to: "/add-data" },
      ], 
     },
    {
      label: "Leads",
      children: [
        { label: "New Lead", to: "/newleads" },
        { label: "My Leads", to: "/myleads" },
        { label: "Validate Lead", to: "/validatelead" },
      ],
    },
    { label: "Profile", to: "/userprofile" },
  ],
};
export default menuConfig;